module.exports = __webpack_public_path__ + "staticfr/media/marcas (4).bab428df.jpg";